// Constantes partagées entre le `<Footer>` (client) et le layout serveur.
// Le footer est fixé en bas de l'écran, caché derrière le contenu ; `<main>`
// réserve un espace de révélation égal à la hauteur réelle du footer, exposée
// par celui-ci dans la variable CSS `--footer-height` (mesurée via ResizeObserver).

/** Fond du footer (Figma `4030:1943`). Posé aussi sur `<body>` pour que le
 *  creux de révélation et les coins arrondis du contenu laissent voir du sombre. */
export const FOOTER_BG = '#252422';

/** Variable CSS portant la hauteur courante du footer (posée sur `:root`). */
export const FOOTER_HEIGHT_VAR = '--footer-height';

/** Repli SSR utilisé tant que le footer n'a pas mesuré sa hauteur côté client. */
export const FOOTER_HEIGHT_FALLBACK = '220px';
